import getCookie from './get-cookie';

interface BaseJwtPayload {
  aud: string;
  exp: number;
  iat: number;
  iss: string;
  jti: string;
  nbf: number;
  sub: string;
}

interface UserJwtPayload extends BaseJwtPayload {
  impersonator?: {
    jti: string;
    roles: string[];
    sub: string;
  };
  relationships?: {
    tutor: unknown;
    client: unknown;
    student: unknown;
  };
  roles: string[];
}

const parseJwt = <T extends BaseJwtPayload>(token: string): T | null => {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      window
        .atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(jsonPayload) as T;
  } catch (error) {
    console.error('Failed to parse JWT:', error);
    return null;
  }
};

export function isUserImpersonated(): boolean {
  const jwtToken = getCookie('vt_authentication_token');
  const jwtPayload = jwtToken ? parseJwt<UserJwtPayload>(jwtToken) : null;
  return Boolean(jwtPayload?.impersonator);
}
